//USAGE : /multisport/events/lives/collect/ 

import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import { Box, Typography, Stack, Switch, CircularProgress, Table, TableHead, TableBody, TableRow, TableCell, Divider, TextField } from "@mui/material";
import { styled } from '@mui/material/styles';
import '../../../../../assets/css/SportEventList.css';
import SelectTeam from "../../../../../components/SelectTeam.js";
import Button from "../../../../../components/Button.js";
import useFetch from "../../../../../hooks/useFetch.js";
import useDelete from "../../../../../hooks/useDelete.js";
import { getAllV2Gamefacts, getAllV2GamefactsModel, getAllV2Players, getAllV2Teams, getV2LiveDetails, postV2Gamefact, postV2SportEvent, deleteV2Gamefact } from "../../../../../../api/index.js";
import SportEventDTO from "../../../../../DTO/SportEventDTO.js";
import SelectPlayer from "../../../../../components/SelectPlayer.js";
import SearchFilterDTO from "../../../../../DTO/SearchFilterDTO.js";
import { getUserProvider } from "../../../../../../actions/auth.js";
import TeamDTO from "../../../../../DTO/TeamDTO.js";
import PlayerDTO from "../../../../../DTO/PlayerDTO.js";
import GameFactModelDTO from "../../../../../DTO/conf/GameFactModelDTO.js";
import GameFactDTO from "../../../../../DTO/GameFactDTO.js";
import { useNotifications } from "../../../../../notifications/NotificationManager.js";
import GameFactModelSaisie, { GamefactInput } from "../../../../../components/gamefact/GameFactModelSaisie.js";
import { GamefactsProvider, useGamefacts } from "../../../../../components/gamefact/GameFactContext.js";
import { convertGameFactTimeToSeconds } from "../../../../../helpers/dateHelper.js";
import { FixedSizeList as List } from 'react-window';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';



const formatDate = (date) => {
    const options = { hour: '2-digit', minute: '2-digit' };
    return new Date(date).toLocaleTimeString([], options);
};

const darkMain = '#4A5168'
const lightGrey = '#E5E7E9'
const whiteAlmost = 'rgb(255,255,255)'

const getPrimary = (event, selectedSport) => {

  if(event.phase?.competitionDiscipline?.discipline?.label === event.phase?.competitionDiscipline?.discipline?.sport?.label){
    return `${event.phase?.competitionDiscipline?.discipline?.sport?.label}`
  }

  let primary = `${!selectedSport ? `${event.phase?.competitionDiscipline?.discipline?.sport?.label} (${event.phase?.competitionDiscipline?.discipline?.label})` : `${event.phase?.competitionDiscipline?.discipline?.label}`}`

  return primary
}

const SportEventList = ({ events, selectedSport }) => {

  const provider = getUserProvider()

  const uniqueDisciplineIds = [...new Set(events.map(e => e.phase.competitionDiscipline.discipline._id))];
  const searchFilter = new SearchFilterDTO({
        global: {
            provider: provider,
        },
        discipline: { _id: uniqueDisciplineIds }
  });

  // Recupérer toutes les team et tous les joueurs ces disciplines actives
  const { data : teamsAvailable, fetchData : fetchTeamsAvailable } = useFetch(getAllV2Teams, [JSON.stringify(searchFilter)]);
  const [teams, setTeams] = useState(null)

  // Recupérer toutes les player et tous les joueurs ces disciplines actives
  const { data : playersAvailable, fetchData : fetchPlayersAvailable } = useFetch(getAllV2Players, [JSON.stringify(searchFilter)]);
  const [players, setPlayers] = useState(null)

  // Récupérer les faits de jeu model

  const searchFilterGameFactModel = new SearchFilterDTO({global : {provider}, competition : { idNameConfig : [events[0].phase.competitionDiscipline.competition.idNameConfig]}});
  const { data : gamefactsModel, fetchData : fetchGamefactsModel } = useFetch(getAllV2GamefactsModel, [JSON.stringify(searchFilterGameFactModel)]);
  const [gamefactsModels, setGamefactsModels] = useState(null)


  const uniqueSportEventIds = [...new Set(events.map(e => e._id))];
  const searchFilterGamefacts = new SearchFilterDTO({
    global: {
      provider: provider,
    },
    sportevent: { _id: uniqueSportEventIds }
  });

  const { data : gamefactsData, fetchData : fetchGamefacts } = useFetch(getAllV2Gamefacts, [JSON.stringify(searchFilterGamefacts)]);
  const [gamefacts, setGamefacts] = useState(null)

  useEffect(() => {
    fetchGamefacts();
    fetchGamefactsModel()
    fetchTeamsAvailable();
    fetchPlayersAvailable();
}, []);
  
  useEffect(() => {
    if(gamefactsData)
      setGamefacts(gamefactsData.map(g => new GameFactDTO(g)))

  }, [gamefactsData])

  useEffect(() => {
    if(!gamefactsModel)
      return
      setGamefactsModels(gamefactsModel.map(g => new GameFactModelDTO(g)))
  }, [gamefactsModel])

  useEffect(() => {
    if(!teamsAvailable)
      return

      setTeams(teamsAvailable.map(t => new TeamDTO(t)))
  }, [teamsAvailable])

  useEffect(() => {
    if(!playersAvailable)
      return

    setPlayers(playersAvailable.map(p => new PlayerDTO(p)))

  }, [playersAvailable])

  if(!teams || !players || !gamefactsModel || !gamefacts || !events )
    return <CircularProgress/>

  return (
    <Box sx={{display : 'flex', alignItems : 'center', flexDirection : 'column', mt : 3}}>
          <Box sx={{width : '100%', overflowX : 'auto', mt : 1, margin : 'auto'}}>
                  {events.map((event, rowIndex) => (
                    <Box key={event._id} sx={{mb : 5}} >
                              <Box className="customBoxSport" sx={{backgroundColor : darkMain, color : whiteAlmost}}
                                >
                                  <Typography className="customTypoSport" sx={{fontWeight : 'bold', padding: '1em', borderRight: '1px solid grey'}}>{formatDate(event.date) + ' - ' + getPrimary(event, selectedSport)}</Typography>
                                  <Box className="customBoxSportDetails">
                                        {event.phase && 
                                        <Typography sx={{padding:'0.8em', display:'grid'}}>
                                          <p>{'phase '}</p><span style={{ fontWeight: 'bold' }}>{event.phase.name }</span>
                                        </Typography>
                                        }
                                        {event.phase && event.phase.epreuve && 
                                        <Typography sx={{padding:'0.8em', display:'grid'}}>
                                          <p>{'épreuve '}</p><span style={{ fontWeight: 'bold' }}>{event.phase.epreuve.name }</span>
                                        </Typography>
                                        }
                                        {event.phase && event.phase.category && 
                                        <Typography sx={{padding:'0.8em', display:'grid'}}>
                                          <p>{'catégorie '}</p><span style={{ fontWeight: 'bold' }}>{event.phase.category.name }</span>
                                        </Typography>
                                        } 
                                    </Box>
                              </Box> 
                              <Box className="customBoxGamefact">
                                <GamefactsProvider initialGamefacts={gamefacts}>
                                  <EditEvent event={event} teamsAvailable={teams} playersAvailable={players} gameFactsAvailable={gamefactsModels} ></EditEvent>
                                </GamefactsProvider>
                              </Box>
                    </Box>       
                  ))} 
          </Box>
        </Box>
  )
};

const EditEvent = ({event, teamsAvailable, playersAvailable, gameFactsAvailable}) => {

  const { addNotification } = useNotifications();

  const [eventState, setEventState] = useState(new SportEventDTO(event))

  const { data, isLoading, error, fetchData } = useFetch(postV2SportEvent, [[eventState]]);

  // Utilisez useRef pour suivre si le composant vient d'être monté
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (!isInitialized) {
      setIsInitialized(true);
      return;
    }

    if(!eventState)
      return

    // Fetch update sportEvent
    fetchData()

  }, [eventState])

  useEffect(() => {
    if(!data)
      return

    // Envoyer une notif au service de notification
    /*addNotification({
      title: 'Edition d\'un évenement sportif',
      type: 'success',
      description: 'Votre évenement sportif '+ getPrimary(event) +' a été modifié avec succès !',
      //link: getRootUrl() +'/live/'+data._id+'/calendar'
  });*/

  }, [data])

  useEffect(() => {

    if(!error)
        return

    // Envoyer une notif au service de notification
    addNotification({
        title: 'Edition d\'un évenement sportif',
        type: 'error',
        description: error.status + ' - ' + error.message,
        //link: getRootUrl() +'/live/'+data._id+'/calendar'
    });

  }, [error])



  const handleChangeType = (e) => {
    setEventState(new SportEventDTO({...eventState, type : e, teams : [], players : []}))
  }

  const handleChangeTeam = (e) => {
    setEventState(new SportEventDTO({...eventState, teams : e}))
  }

  const handleChangePlayer = (e) => {
    setEventState(new SportEventDTO({...eventState, players : e}))
  }

  if(!eventState)
    return <CircularProgress/>


  return <SelectRessources event={eventState} 
                              handleChangeTeam={handleChangeTeam} 
                              handleChangePlayer={handleChangePlayer} 
                              handleChangeType={handleChangeType}
                              teamsAvailable={teamsAvailable} 
                              playersAvailable={playersAvailable}
                              gameFactsAvailable={gameFactsAvailable}
            />            
}

const SelectRessources = ({event, handleChangeType, handleChangePlayer, handleChangeTeam, teamsAvailable, playersAvailable, gameFactsAvailable}) => {
  
  const [ressources, setRessources] = useState()

  const {createGamefacts, gamefacts, updateGamefact, deleteGamefact, createGamefact} = useGamefacts()

  const [defaultValueGamefactModel, setDefaultValueGamefactModel] = useState({})

  const handleEditDefaultValueGamefactModel = (name, value) => {
    let newDefaultValue = {...defaultValueGamefactModel}

    if(value)
      newDefaultValue[name] = value
    else
      delete newDefaultValue[name]

    setDefaultValueGamefactModel(newDefaultValue)
  }

  const handleAddRessource = () => {
    setRessources(s => ([...s, {}]))
  }

  const handleRemoveRessource = (idx) => {
    setRessources(s => s.filter((_, index) => index !== idx))
  }

  const handleChangeRessource = async (e, idx) => {
    const gamefactstoCreate = []
    setRessources(s => s.map((r, index) => {
      if(idx === index){

        // Ici, s'il s'agit d'une nouvelle ressource, on veut créer les gameFact qui ont une défault value
        if(!r._id && e.target.value){
          // Pour chaque valeur par défaut on crée le fait de jeu si la ressource à cet event n'a pas encore le fait de jeu
          Object.keys(defaultValueGamefactModel).forEach(key => {
            // On regarde si la ressource n'a pas deja un fait de jeu : 
            const existingGameFact = gamefacts.find(g => g.details.actor[event.type] && g.details.actor[event.type]._id === e.target.value && g.event && g.event._id === event._id && g.type.name === key)

            if(!existingGameFact){
              const gfModel = gameFactsAvailable.find(gf => gf.type.name === key)

              if (!gfModel) {
                  return;
                }

                let convertValue = defaultValueGamefactModel[key];
                convertValue = convertGameFactTimeToSeconds(gfModel, convertValue);

                if (convertValue === undefined) {
                  return;
                }

              const gameFactData = {
                //_id : undefined,
                name : gfModel.type.name,
                idName: gfModel.idName,
                event : {_id : event._id},
                type : {
                  ...gfModel.type,
                  value : convertValue,
                },
          
                details : {
                  actor : {
                    [event.type] : {_id : e.target.value}
                  },
                  time : 0,
                  period : 0,
                  success : true
                },
          
                provider : getUserProvider()
              }
              //createGamefact(new GameFactDTO(gameFactData))
  
              // ajoute les gamefact a crééer
              gamefactstoCreate.push(new GameFactDTO(gameFactData))
            }
          })

          // CAS PARTICULIER CLASSEMENT
          const gfClassementModel = gameFactsAvailable.find(gf => gf.type.name === 'Classement')
          const existingClassementGameFact = gamefacts.find(g => g.details.actor[event.type] && g.details.actor[event.type]._id === e.target.value && g.event && g.event._id === event._id && g.type.name === 'Classement')
          if(!existingClassementGameFact && !defaultValueGamefactModel['Classement'] && gfClassementModel){

              const gameFactData = {
                //_id : undefined,
                name : gfClassementModel.type.name,
                idName: gfClassementModel.idName,
                event : {_id : event._id},
                type : {
                  ...gfClassementModel.type,
                  value : ressources.length,
                },
          
                details : {
                  actor : {
                    [event.type] : {_id : e.target.value}
                  },
                  time : 0,
                  period : 0,
                  success : true
                },
          
                provider : getUserProvider()
              }
  
              // ajoute les gamefact a crééer
              gamefactstoCreate.push(new GameFactDTO(gameFactData))
          }
        }

        return {...r, _id : e.target.value}
      }
      
      return r
    }))

    if(gamefactstoCreate && gamefactstoCreate.length){
      const { data } = await postV2Gamefact(gamefactstoCreate)
      createGamefacts(data)
    }
    
  }

  const isUpdateEventState = (ressources, event) => {
    // Déterminer le tableau de référence dans l'objet event selon le type d'événement
    const referenceArray = event.type === 'team' ? event.teams : event.players;
  
    // Vérifier si la taille des tableaux est différente
    if (ressources.length !== referenceArray.length) {
      return true; // Différence dans la taille des tableaux
    }
  
    // Vérifier si les _id à chaque index correspondent entre les deux tableaux
    for (let i = 0; i < ressources.length; i++) {
      // Si l'un des objets dans ressources ou le tableau de référence n'a pas de _id, ou s'ils sont différents
      if (!ressources[i]._id || !referenceArray[i]._id || ressources[i]._id !== referenceArray[i]._id) {
        return true; // Différence trouvée dans les _id
      }
    }
  
    // Aucune différence trouvée, pas besoin de mettre à jour l'état
    return false;
  };

  useEffect(() => {
    // Si tout est valorisé, on balance au parent
    if(!ressources || ressources.some(r => !r._id))
      return

    // Appeler isUpdateEventState pour vérifier s'il y a besoin de mettre à jour
    if (isUpdateEventState(ressources, event)) {
      event.type === 'team' ? handleChangeTeam(ressources) : handleChangePlayer(ressources);
    }
  }, [ressources])

  useEffect(() => {
    if(event.type === 'team')
      setRessources(event.teams && [...event.teams])

    if(event.type === 'player')
      setRessources(event.players && [...event.players])
  }, [,event.type])


  const getVisibleRessources = useCallback((ressource) => {

    if(event.type === 'team'){
      return teamsAvailable.filter(team => 
        team.disciplines.some(discipline => discipline._id === event.phase.competitionDiscipline.discipline._id) && (
          team._id === ressource._id ||
          !event.teams.some(eventTeam => eventTeam._id === team._id)
        )
      )
    }

    if(event.type === 'player'){
      return playersAvailable.filter(player => 
        player.disciplines.some(discipline => discipline._id === event.phase.competitionDiscipline.discipline._id) && (
          player._id === ressource._id ||
          !event.players.some(eventTeam => eventTeam._id === player._id)
        )
      )
    }
  }, [event, teamsAvailable, playersAvailable])

  const handleSort = (gamefactIdName, order = 1) => {

    const gfModel = gameFactsAvailable.find(g => g.idName === gamefactIdName)

        if(!gfModel)
          return
  
    setRessources(prevRessources => {
      return [...prevRessources].sort((a, b) => {

        // Trouver les gamefacts pour a et b
        const aGamefact = gamefacts.find(g => 
          a && event && g.details.actor[event.type]?._id === a._id && g.event._id === event._id && gamefactIdName === g.idName
        );
        const bGamefact = gamefacts.find(g => 
          b && event && g.details.actor[event.type]?._id === b._id && g.event._id === event._id && gamefactIdName === g.idName
        );

        if(gfModel.type.format === 'string'){
          // Obtenir les valeurs de type
          let aValue = aGamefact ? aGamefact.type.value : "z";
          let bValue = bGamefact ? bGamefact.type.value : "z";

          // Comparer les valeurs
          return order * aValue.localeCompare(bValue);
        }else{
          // Obtenir les valeurs de type
          let aValue = aGamefact ? aGamefact.type.value : 0;
          let bValue = bGamefact ? bGamefact.type.value : 0;

          // Comparer les valeurs
          return order * (aValue - bValue);
        }
  
        
      });
    });
  }



  if(!ressources)
    return <CircularProgress/>

    return<div style={{ display: 'flex', flexDirection: 'column', width: '100%'}}>
    {/*<Box display='flex' alignItems={'center'} width="100%">
          <Box sx={{p : 0 , m : 0, width : 250, minWidth : 250, maxWidth : 250, textAlign : 'center'}}>
          </Box>
          {gameFactsAvailable && gameFactsAvailable.map((gfModel, idx) => 
                  <Box sx={{p : 0 , m : 0, width : 250, minWidth : 250, maxWidth : 250, textAlign : 'center'}}>
                    <Typography>{gfModel.type.name}</Typography>
                  </Box>

                  
            )}


    </Box>*/}
  <Box textAlign={'center'} mb={4}>
    <TypeSwitch eventType={event.type} handleChange={handleChangeType}/>
  </Box>
    
        
    <VirtualizedTable 
                            ressources={ressources} 
                            handleRemoveRessource={handleRemoveRessource}
                            handleAddRessource={handleAddRessource}
                            event={event}
                            teamsAvailable={teamsAvailable} 
                            playersAvailable={teamsAvailable} 
                            getVisibleRessources={getVisibleRessources} 
                            handleChangeRessource={handleChangeRessource}
                            gameFactsAvailable={gameFactsAvailable}

                            handleEditDefaultValueGamefactModel={handleEditDefaultValueGamefactModel}
                            defaultValueGamefactModel={defaultValueGamefactModel}

                            handleSort={handleSort}
                            createGamefact={createGamefact}
                            gamefacts={gamefacts}
                            updateGamefact={updateGamefact}
                            deleteGamefact={deleteGamefact}
                            
                  />

  </div>


    return <Box width='100%' textAlign={'center'}>
      
      {ressources.length>0 && <><Table>
        <TableHead>
          <TableRow>
            <TableCell>

            </TableCell>
            {gameFactsAvailable && gameFactsAvailable.map((gfModel, idx) => 
                <TableCell>
                  <Typography>{gfModel.type.name}</Typography>
                </TableCell>
            )}
          </TableRow>
          <TableRow>
            <TableCell>
              <Button disabled={!Object.keys(defaultValueGamefactModel).length} onClick={() => setDefaultValueGamefactModel({})}>Réinitialiser</Button>
            </TableCell>
            {gameFactsAvailable && gameFactsAvailable.map((gfModel, idx) => 
                <TableCell key={gfModel.type.name}>
                  <GamefactInput gameFactModel={gfModel} selectedValue={
                    defaultValueGamefactModel[gfModel.type.name] || ''}   key={idx}
                  toggle={(value) => {
                    if(defaultValueGamefactModel[gfModel.type.name] === value)
                      handleEditDefaultValueGamefactModel(gfModel.type.name, undefined)
                    else
                      handleEditDefaultValueGamefactModel(gfModel.type.name, value)
                      
                    }
                  }
                  change={(value) => { 
                    handleEditDefaultValueGamefactModel(gfModel.type.name, value)
                    } }/>
                </TableCell>
            )}
          </TableRow>
        </TableHead>
        </Table>
                <VirtualizedTable 
                            ressources={ressources} 
                            handleRemoveRessource={handleRemoveRessource}
                            event={event}
                            teamsAvailable={teamsAvailable} 
                            playersAvailable={teamsAvailable} 
                            getVisibleRessources={getVisibleRessources} 
                            handleChangeRessource={handleChangeRessource}
                            gameFactsAvailable={gameFactsAvailable}

                            handleEditDefaultValueGamefactModel={handleEditDefaultValueGamefactModel}
                            defaultValueGamefactModel={defaultValueGamefactModel}
                  />
      </>}
      <br/>
      
    </Box>
}

const Row = ({ index, style, data }) => {
  const { ressources, unfilteredRessources, filter, handleRemoveRessource, event, teamsAvailable, playersAvailable, getVisibleRessources, handleChangeRessource, gameFactsAvailable,
    gamefacts, createGamefact, updateGamefact, deleteGamefact
  } = data;
  const ressource = ressources[index];

  const visibleRow = (ressource.name && ressource.name.toLowerCase().includes(filter)) || 
    (ressource.lastname && ressource.lastname.toLowerCase().includes(filter)) || 
    (ressource.firstname && ressource.firstname.toLowerCase().includes(filter)) ||
    (Object.keys(ressource).length <= 1)

  const unfilteredIndex = unfilteredRessources.indexOf(ressource)

  return (
    <div style={{ ...style, display: 'flex', flexDirection: 'row', width: '100%' }} >
            <Box display='flex' sx={{p : 0 , m : 0, width : 250, minWidth : 250, maxWidth : 250}} key={unfilteredIndex}>
              <Button sx={{ minWidth: "20px", height: "20px", p: "0.8em", m: "0.8em"}} onClick={() => handleRemoveRessource(unfilteredIndex)}>-</Button>
              {event.type && (teamsAvailable || playersAvailable) && (
                <>
                  {event.type === 'team' ? 
                    <SelectTeam
                      teams={getVisibleRessources(ressource)}
                      name="team"
                      selectedTeam={ressource._id}
                      handleChange={(e) => handleChangeRessource(e, unfilteredIndex)}
                    />
                  :
                    <SelectPlayer
                      players={getVisibleRessources(ressource)}
                      name="player"
                      selectedPlayer={ressource._id}
                      handleChange={(e) => handleChangeRessource(e, unfilteredIndex)}
                    />
                  }
                </>
              )}
            </Box>
          {gameFactsAvailable && gameFactsAvailable.map((gfModel, idx) => (
              <Box sx={{p : 0 , m : 0, width : 150, minWidth : 150, maxWidth : 150, textAlign : 'center'}} key={idx}>
                <GameFactModelSaisie
                  gameFactModel={gfModel}
                  ressourceParam={event.type}
                  ressource={ressource}
                  event={event}

                  gamefacts={gamefacts}
                  createGamefact={createGamefact}
                  updateGamefact={updateGamefact}
                  deleteGamefact={deleteGamefact}
                />
              </Box>
          ))}
          
    </div>
  );
};

const Header = ({ handleFilterChange,gameFactsAvailable, scrollLeft, handleEditDefaultValueGamefactModel, defaultValueGamefactModel, handleSort }) => {

  const [actualSort, setActualSort] = useState({idName : 'ranking', order : 1})

  useEffect(() => {
    handleSort(actualSort.idName, actualSort.order)
  }, [ ,actualSort])

  const handleChangeSort = (idName) => {
    if(actualSort.idName === idName){
      setActualSort(s => ({idName, order : -1*s.order}))
    }else{
      setActualSort({idName, order : 1})
    }
  }




  return (
  <Box display="flex" flexDirection={"column"} mb={3}
  sx={{position: 'sticky', top: 0, zIndex: 1, marginLeft: '-'+scrollLeft+'px' }}
  >
      <Box
          display='flex'
          alignItems='center'
          width="fit-content"
        >
          <Box sx={{ p: 0, m: 0, width: 250, minWidth: 250, maxWidth: 250, textAlign: 'center' }}>
              <Typography variant="h6">Resource</Typography>
          </Box>
          {gameFactsAvailable && gameFactsAvailable.map((gfModel, idx) => 
            <Box key={idx} sx={{ p: 0, m: 0, width: 150, minWidth: 150, maxWidth: 150, textAlign: 'center', display : 'flex', justifyContent : 'space-around' }} onClick={() => handleChangeSort(gfModel.idName)}>
              <Typography variant="h6" sx={{ fontSize: 15 }}>{gfModel.type.name}</Typography>
              {actualSort.idName === gfModel.idName && (
                actualSort.order === 1 ? <ArrowUpwardIcon sx={{ fontSize: 20 }} /> : <ArrowDownwardIcon sx={{ fontSize: 20 }} />
              )}
            </Box>
          )}
        </Box>

        <Box
          display='flex'
          alignItems='center'
          width="fit-content"
          sx={{ borderBottom: '1px solid #ccc'}}
        >
          <Box sx={{ p: 0, m: 0, width: 250, minWidth: 250, maxWidth: 250, textAlign: 'center' }}>
              <TextField name="filter" onChange={(e) => handleFilterChange(e.target.value)}></TextField>
          </Box>
          {gameFactsAvailable && gameFactsAvailable.map((gfModel, idx) => 
              <Box key={idx} sx={{ p: 0, m: 0, width: 150, minWidth: 150, maxWidth: 150, textAlign: 'center' }}>
                <GamefactInput gameFactModel={gfModel} selectedValue={
                  defaultValueGamefactModel[gfModel.type.name] || ''}   key={idx}
                toggle={(value) => {
                  if(defaultValueGamefactModel[gfModel.type.name] === value)
                    handleEditDefaultValueGamefactModel(gfModel.type.name, undefined)
                  else
                    handleEditDefaultValueGamefactModel(gfModel.type.name, value)
                    
                  }
                }
                change={(value) => { 
                  handleEditDefaultValueGamefactModel(gfModel.type.name, value)
                  } }/>
              </Box>
          )}
        </Box>

            
  </Box>
  )
};

const VirtualizedTable = ({ ressources, 
  handleRemoveRessource, handleAddRessource,
  event, teamsAvailable, playersAvailable, getVisibleRessources, 
  handleChangeRessource, 
  gameFactsAvailable, handleEditDefaultValueGamefactModel, defaultValueGamefactModel,
  handleSort,
  gamefacts, createGamefact, updateGamefact, deleteGamefact }) => {


  const [filter, setFilter] = useState('');
  const listRef = useRef(null);
  const [scrollLeft, setScrollLeft] = useState(0);

  

  const handleFilterChange = (value) => {
    setFilter(value.toLowerCase());
  };

  const filteredRessources = ressources.filter(r => 
    (r.name && r.name.toLowerCase().includes(filter)) || 
    (r.lastname && r.lastname.toLowerCase().includes(filter)) || 
    (r.firstname && r.firstname.toLowerCase().includes(filter)) ||
    (Object.keys(r).length <= 1)
  );


  useEffect(() => {
    const handleScroll = () => {
      if (listRef.current) {
        const { scrollLeft } = listRef.current;
        setScrollLeft(scrollLeft);
      }
    };

    const listOuterElement = listRef.current;

    if (listOuterElement) {
      listOuterElement.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (listOuterElement) {
        listOuterElement.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  const itemData = {
    filter,
    unfilteredRessources : ressources,
    ressources : filteredRessources,
    handleRemoveRessource,
    event,
    teamsAvailable,
    playersAvailable,
    getVisibleRessources,
    handleChangeRessource,
    gameFactsAvailable,

    gamefacts, createGamefact, updateGamefact, deleteGamefact
  }

  return (
    <Box textAlign={'center'}>
        <Header handleFilterChange={handleFilterChange} gameFactsAvailable={gameFactsAvailable} scrollLeft={scrollLeft} handleEditDefaultValueGamefactModel={handleEditDefaultValueGamefactModel} defaultValueGamefactModel={defaultValueGamefactModel} handleSort={handleSort}/>
        <List
          height={600} // Adjust height according to your requirements
          itemCount={filteredRessources.length}
          itemSize={100} // Adjust item size according to your requirements
          itemData={itemData}
          width="100%"
          outerRef={listRef}
        >
          {Row}
        </List>
        <Button sx={{minWidth : "20px", height : "20px", p : '1.1em', m : '1em'}} onClick={handleAddRessource} disabled={filter || ressources.some(r => Object.keys(r).length === 0)}>Ajouter une ressource</Button>
    </Box>
  );
};

// Création d'un switch plus petit avec styled
const SmallSwitch = styled(Switch)(({ theme }) => ({
  padding: 1, // Ajustez la padding pour réduire la taille
  width : 'auto',
  height : 'auto',
  '& .MuiSwitch-switchBase': {
    padding: 1, // Ajustez la padding du bouton du switch
    '&.Mui-checked': {
      transform: 'translateX(12px)', // Ajustez en fonction de la taille du switch
    },
  },
  '& .MuiSwitch-input': {
    width: 30, // Ajustez la taille du thumb
  },
  '& .MuiSwitch-thumb': {
    width: 12, // Ajustez la taille du thumb
    height: 12, // Ajustez la hauteur du thumb
  },
  '& .MuiSwitch-track': {
    borderRadius: 22 / 2, // Ajustez le radius du track
    height : '12px',
    width : '23px'
  },
}));

const TypeSwitch = ({eventType = 'team', handleChange}) => {

  const [type, setType] = React.useState(eventType); // 'joueur' ou 'equipe'

  const handleChangeType = (event) => {
    handleChange(event.target.checked ? 'team' : 'player')
  };

  // Utilisez useRef pour suivre si le composant vient d'être monté
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (!isInitialized) {
      setIsInitialized(true);
      return;
    }

    setType(eventType)

  }, [eventType])

  // Retourner un switch 
  return (
    <Stack direction="row" spacing={1} alignItems="center" display={'inline-flex'} width='fit-content'>
      <Typography>Joueur</Typography>
      <SmallSwitch
        checked={type === 'team'}
        onChange={handleChangeType}
        inputProps={{ 'aria-label': 'Mode joueur ou équipe' }}
      />
      <Typography>Équipe</Typography>
    </Stack>
  );

}

export default SportEventList